/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { TabsNav, TabsNavItem } from "../TabsNav";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import ViewFixed from "../ViewFixed";
import DataTable from "../DataTable";

class ResultsReviewUtility extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            currentItem: {}
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.load();
    }

    groupList = (list) => {
        let grouped = {};
        list.forEach(row => {
            if (!grouped[row.specimen.sid])
                grouped[row.specimen.sid] = { sid: row.specimen.sid, specimen: row.specimen, rows: [] };
            grouped[row.specimen.sid].rows.push(row);
        });



        let result = [];
        for (let k in grouped) {
            if (!grouped[k].panels)
                grouped[k].panels = [];

            grouped[k].rows.forEach(row => {
                let panel = grouped[k].panels.find(a => a.id === row.panel.id);

                if (panel)
                    panel.tests.push(row);
                else
                    grouped[k].panels.push({ id: row.panel.id, code: row.panel.code, name: row.panel.name, tests: [row] });
            });
            result.push(grouped[k]);
        }

        return result;
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/result/review/list');
            if (j.list)
                this.setState({ list: this.groupList(j.list) });
            else if (j.errorCode)
                this.alert(j.errorMesage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    toggle = (row) => {
        row.show = !row.show;
        this.setState({ list: this.state.list });
    }

    editResult = (target) => {
        target.editResult = true;
        this.setState({ list: this.state.list });
    }

    changeResult = (e, target) => {
        target.result.stringResult = e.target.value;
        this.setState({ list: this.state.list });
    }

    saveResult = async (target, row) => {
        try {
            let numericResult = 0;
            try {
                numericResult = parseFloat(target.result.stringResult);
                if (isNaN(numericResult))
                    numericResult = 0;
            }
            catch { }
            let j = await qreq.postAsync('/api/result/save', { specimenID: row.specimen.id, targetID: target.id, stringResult: target.result.stringResult, numericResult: numericResult, referenceRange: target.refRange, units: target.units });
            if (j.errorCode === 0) {
                target.editResult = false;
                this.setState({ list: this.state.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    select = (row) => {
        console.log('row', row);
        this.setState({ currentItem: row });
    }

    render() {
        return <>
            <ViewFixed left="0" top="0" bottom="50vh" right="0" zIndex="100000" className="bg-white">
                <DataTable
                    sticky
                    columns={[
                        { name: 'name', title: 'Target'},
                        { name: 'result', title: 'Result', valueFunc: z => z.result?.stringResult },
                        { name: 'refRange', title: 'Ref Range' },
                        { name: 'units', title: 'Units' },
                    ]}
                    data={this.state.currentItem?.rows || []}
                />
            </ViewFixed>
            <ViewFixed left="0" top="50vh" bottom="0" right="0" zIndex="100000" className="bg-white">
                <DataTable
                    sticky
                    columns={[
                        { name: 'specimen', title: 'Specimen', valueFunc: (row) => row.specimen.sid },
                        { name: 'patientName', title: 'Patient', valueFunc: (row) => row.specimen.order.patient.fullName },
                        { name: 'accountName', title: 'Account', valueFunc: (row) => row.specimen.order.accountName },
                        { name: 'collectedDate', title: 'Collected', valueFunc: (row) => Globals.toMDYHMLocalDateStringOrDiff(row.specimen.collectedDate) }
                    ]}
                    data={this.state.list}
                    onRowClick={this.select}
                />
            </ViewFixed>
        </>;
    }
}

export default withParamsAndNavigate(ResultsReviewUtility);